import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import SendEmailMutation from './SendEmailMutation';

class SendEmailConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createSendEmail = mutate => async request => {
        const variables = {
            request,
        };

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={SendEmailMutation}>
                {mutate =>
                    children({
                        sendEmail: this.createSendEmail(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default SendEmailConnectorApollo;
